module.exports = "<div class=\"widgets\">\n\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <ba-card cardTitle=\"Sector List\" baCardClass=\"with-scroll\">\n        <sector-list></sector-list>\n      </ba-card>\n    </div>\n\n    <div class=\"col-md-4\">\n      <ba-card cardTitle=\"New Sector\" baCardClass=\"with-scroll\">\n        <sector-form></sector-form>\n      </ba-card>\n    </div>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/localization/components/sectors/sectors.component.html
// module id = 874
// module chunks = 8